import { USER_INFO_LOADED } from '../constants/actionTypes';

const initialState = {
  tier: 'free'
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case USER_INFO_LOADED:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
